module.exports = __webpack_public_path__ + "static/media/2S.e8c6e1db.svg";